<template>

    <Collaboration :content="data.collaboration"/>
    <ProductSlider :content="data.product_sliders"/>
    <SingleProduct :content="data.single_product"/>
    <CategorySection :content="data.featured_categories"/>
    <CollectionSlider :content="data.collection_slider"/>
    <FirmSection v-if="data.length > 0"/>
    <Viewed v-if="data.length > 0"/>
    <OfflineStoresSec />
</template>

<script>
import Collaboration from "../../components/Home/collaboration.vue"
import ProductSlider from "../../components/Home/products-sec.vue"
import SingleProduct from "../../components/Home/single-product-sec.vue"
import CategorySection from "../../components/Home/category-sec.vue"
import CollectionSlider from "../../components/Home/collection-slider-sec.vue"
import FirmSection from "../../components/Home/firm-sec.vue"
import OfflineStoresSec from "../../components/Home/offline-stores-sec.vue"
import Viewed from '../../components/viewed.vue'
export default {

    components:{
        Collaboration,ProductSlider,SingleProduct,CategorySection,CollectionSlider,Viewed,FirmSection,OfflineStoresSec
    },
    name: "index",
    data(){
        return{
            data:[],
        }

    } ,
    computed: {
        pageTitle() { return this.$route.meta.title; }
    },
    watch:{
        $route(toRoute){



        }
    },
    mounted() {
        this.getContent()

    },
    methods:{
        async getContent() {
            if( this.$store.state.settings.contents){
                this.data = this.$store.state.settings.contents
            }else {
                await axios.get('/api/v1/get-content', {params:this.setParam()})
                    .then(data => {
                        this.data = data.data
                        this.$store.state.settings.contents = data.data


                    })
            }

        },
    }

}
</script>

<style scoped>

</style>
